/**
 * Copyright (c) 2023 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { BrandColors, MaterialIcon, Text } from '@blend/enterprise-components';
import { StyleSheet, css } from 'aphrodite';

const styles = StyleSheet.create({
  iconWrapper: {
    marginRight: 5,
    verticalAlign: 'middle',
    display: 'inline',
  },
  noIcon: {
    paddingLeft: 21,
  },
});

export const IconCell: React.FC<{ value: { status?: string; icon: string } }> = ({ value }) => {
  if (!value.status) {
    return null;
  }
  return (
    <div className={!value.icon ? css(styles.noIcon) : undefined}>
      {value.icon && (
        <div className={css(styles.iconWrapper)}>
          <MaterialIcon
            fontWeight="BOLD"
            color={value.icon === 'check' ? BrandColors.ACCENT_GREEN : BrandColors.ACCENT_RED}
            size={16}
            type={value.icon as MaterialIcon.Props['type']}
          />
        </div>
      )}
      <Text>{value.status}</Text>
    </div>
  );
};
